import { ProfileInfoType, UserInfoType } from '@/types/profile';

/**
 * Get the display name for a user with consistent fallback logic:
 * 1. Display name
 * 2. First name + Last name
 * 3. Username
 * 4. Fallback text (optional)
 */
export const getUserDisplayName = (
    // Accept different possible data structures
    options: {
    // User data from various sources
    userData?: UserInfoType | null;
    // Direct profile info
    profileInfo?: ProfileInfoType | null;
    // Basic user info
    displayName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    username?: string | null;
    // Optional fallback text if nothing else is available
    fallback?: string;
  }
): string => {
    const {
        userData,
        profileInfo,
        displayName: directDisplayName,
        firstName: directFirstName,
        lastName: directLastName,
        username: directUsername,
        fallback = '',
    } = options;

    // Prefer profile document displayName over nested userData (often stale until refetch).
    const displayName =
        directDisplayName ||
        profileInfo?.displayName ||
        userData?.displayName ||
        profileInfo?.userData?.displayName;

    if (displayName) {
        return displayName;
    }

    // Try first name + last name from all possible sources
    const firstName =
    directFirstName ||
    userData?.firstName ||
    profileInfo?.userData?.firstName;

    const lastName =
    directLastName ||
    userData?.lastName ||
    profileInfo?.userData?.lastName;

    const fullName = `${firstName || ''} ${lastName || ''}`.trim();
    if (fullName) {
        return fullName;
    }

    // Try username from all possible sources
    const username =
    directUsername ||
    userData?.username ||
    profileInfo?.userData?.username ||
    profileInfo?.username;

    if (username) {
        return username;
    }

    // Return fallback text if nothing else is available
    return fallback;
};
